import { render, staticRenderFns } from "./AddParticipant.vue?vue&type=template&id=4bd9b3b4"
import script from "./AddParticipant.vue?vue&type=script&lang=js"
export * from "./AddParticipant.vue?vue&type=script&lang=js"
import style0 from "./AddParticipant.vue?vue&type=style&index=0&id=4bd9b3b4&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports